import React from 'react';
import { isSameMonth, isToday } from 'date-fns';
import { classNames } from '../utils/classNames';
import { useStyles } from '../styles';

const CalendarDay = ({
    date,
    currentMonth,
    onClick,
    onMouseEnter,
    isInRange,
    isRangeStart,
    isRangeEnd,
    disabled = false
}) => {
    const classes = useStyles();

    const handleClick = () => {
        if (!disabled) {
            onClick(date);
        }
    };

    const handleMouseEnter = () => {
        if (!disabled && onMouseEnter) {
            onMouseEnter(date);
        }
    };

    const isCurrentMonth = isSameMonth(date, currentMonth);
    const isTodayDate = isToday(date);

    return (
        <button
            type="button"
            className={classNames(classes.day, {
                [classes.dayOutsideMonth]: !isCurrentMonth,
                [classes.dayInRange]: isInRange && !isRangeStart && !isRangeEnd,
                [classes.dayRangeStart]: isRangeStart,
                [classes.dayRangeEnd]: isRangeEnd,
                [classes.dayToday]: isTodayDate && !isRangeStart && !isRangeEnd
            })}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            disabled={disabled}
        >
            {date.getDate()}
        </button>
    );
};

export default CalendarDay;
